import React, { useState, useEffect} from "react"
import Select from "react-select"

import { defaultAvailabilityOption } from "../../objects/availabilityObjects"
import { AvailabilityRulesData } from "../../types/availabilityTypes"

interface Props {
  availabilities: AvailabilityRulesData[]
  handleAvailabilityRulesChange: (selectedOption: AvailabilityRulesData) => void
  serviceType: string
  service?: any
  serviceValues?: any
}

const AvailabilityRulesSelect: React.FC<Props> = ({
  availabilities,
  serviceType,
  handleAvailabilityRulesChange,
  service,
  serviceValues,
}) => {
  const [availabilityOptions, setAvailabilityOptions] = useState(
    defaultAvailabilityOption
  )
  const [activeAvailability, setActiveAvailability] =
    useState<AvailabilityRulesData | null>(null)

  useEffect(() => {
    const defaultAvailability = availabilities?.find((a) => a?.is_default)
    const existingServiceAvailability = availabilities?.find(
      (a) => serviceValues?.availability_rule_id === a.id
    )
    const options = availabilities?.map((a) => ({
      value: a.name,
      label: a.name,
    }))
    const currentAvailability =
      existingServiceAvailability || defaultAvailability || availabilities[0]

    setAvailabilityOptions(options || defaultAvailabilityOption)
    setActiveAvailability(currentAvailability)
    handleAvailabilityRulesChange(currentAvailability)
  }, [
    availabilities,
    service?.availability_rule_id,
    service?.group,
    serviceType,
  ])

  const handleAvailabilityOptionSelect = (e: any) => {
    const selectedOption = availabilities.find((a) => a.name === e.value)
    if (selectedOption) {
      setActiveAvailability(selectedOption)
      handleAvailabilityRulesChange(selectedOption)
    }
  }

  return (
    <div className="flex flex-col">
      <h4 className="font-bold text-base mb-[8px]">Availability</h4>
      <Select
        className="basic-single w-full"
        classNamePrefix="select"
        value={availabilityOptions.filter((a) => {
          return a.value === activeAvailability?.name
        })}
        options={availabilityOptions}
        name="availability"
        onChange={handleAvailabilityOptionSelect}
        isDisabled={
          service.enrolled_count >= 1 && service.is_group_service === true
        }
      />
    </div>
  )
}

export default AvailabilityRulesSelect
